function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { orders as ordersService } from "../../services";
import { t } from "../../helpers/i18n";
export var getById = function getById(orderId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(dispatch, getState) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", ordersService.getById(orderId).then(function (order) {
              var state = getState();
              var currentOrder = state.orders.data.find(function (o) {
                return o.id === order.id;
              });
              if (!currentOrder || currentOrder.status !== order.status) {
                dispatch(getList(state.orders.offset, state.orders.filter, state.orders.orderBy, true));
              } else {
                dispatch({
                  type: 'ORDER_GET_SUCCESS',
                  order: order
                });
              }
              return order;
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var getList = function getList(offset, filter, orderBy, forceUpdate, createdBefore, signedBefore) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dispatch, getState) {
      var state, page;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            dispatch({
              type: 'ORDERS_GET_REQUEST'
            });
            _context2.prev = 1;
            state = getState();
            _context2.next = 5;
            return ordersService.getPage(offset, filter, orderBy, state.session.user.userId, forceUpdate, createdBefore, signedBefore);
          case 5:
            page = _context2.sent;
            dispatch({
              type: 'ORDERS_GET_SUCCESS',
              orders: page.data.map(function (item) {
                return _objectSpread(_objectSpread({}, item), {}, {
                  documents: item.documents || [],
                  attachments: item.attachments || [],
                  metaData: _objectSpread(_objectSpread({}, item.metaData), {}, {
                    lastUpdated: item.metaData.lastUpdated || item.metaData.created
                  })
                });
              }),
              offset: offset,
              filter: filter,
              orderBy: orderBy,
              total: page.total
            });
            _context2.next = 13;
            break;
          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](1);
            console.error(_context2.t0);
            dispatch({
              type: 'ORDERS_GET_FAILURE',
              message: _context2.t0.message
            });
          case 13:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 9]]);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var saveSigner = function saveSigner(orderId, signerId) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(dispatch, getState) {
      var state, order, signer;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            state = getState();
            order = orderId === 'create' ? state.create : state.orders.find(function (order) {
              return order.id === order.id;
            }); // TODO: Remove hard coded 'create'
            signer = order.data.signers.find(function (signer) {
              return signer.id === signerId;
            });
            dispatch({
              type: 'RECIPIENT_SAVE_REQUEST',
              id: signerId
            });
            if (!signer.isSaving) {
              _context3.next = 6;
              break;
            }
            return _context3.abrupt("return");
          case 6:
            return _context3.abrupt("return", ordersService.saveSigner(order.data.id, signer.data, signer.isNew).then(function (savedSigner) {
              dispatch({
                type: 'RECIPIENT_SAVE_SUCCESS',
                id: signerId
              });
              dispatch({
                type: 'UPDATE_RECIPIENT',
                id: signerId,
                recipient: {
                  data: _objectSpread(_objectSpread({}, savedSigner), {}, {
                    id: savedSigner.id
                  }),
                  isNew: false,
                  isDirty: false
                }
              });
            })["catch"](function (err) {
              if (err.statusCode == 409) {
                dispatch({
                  type: 'RECIPIENT_SAVE_FAILURE',
                  id: signerId,
                  error: {
                    statusCode: 409,
                    message: [t('recipient_validation_duplicate_signer')]
                  }
                });
              } else {
                dispatch({
                  type: 'RECIPIENT_SAVE_FAILURE',
                  id: signerId,
                  error: {
                    statusCode: 400,
                    message: [t('recipient_validation_unknown_api_error')]
                  }
                });
              }
              throw err;
            }));
          case 7:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export var removeSigner = function removeSigner(orderId, signerId) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(dispatch, getState) {
      var state, order, signer;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            state = getState();
            order = orderId === 'create' ? state.create : state.orders.find(function (order) {
              return order.id === order.id;
            }); // TODO: Remove hard coded 'create'
            signer = order.data.signers.find(function (signer) {
              return signer.id === signerId;
            });
            return _context4.abrupt("return", ordersService.removeSigner(order.data.id, signer.data.id));
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();
};
export var removeFile = function removeFile(orderId, fileId, category) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(dispatch) {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return ordersService.removeFile(orderId, fileId);
          case 2:
            _context5.t0 = category;
            _context5.next = _context5.t0 === 'document' ? 5 : _context5.t0 === 'attachment' ? 7 : 9;
            break;
          case 5:
            dispatch({
              type: 'REMOVE_DOCUMENT',
              id: fileId
            });
            return _context5.abrupt("break", 10);
          case 7:
            dispatch({
              type: 'REMOVE_ATTACHMENT',
              id: fileId
            });
            return _context5.abrupt("break", 10);
          case 9:
            return _context5.abrupt("break", 10);
          case 10:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x9) {
      return _ref5.apply(this, arguments);
    };
  }();
};
export var addFiles = function addFiles(orderId, payload) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(dispatch) {
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return ordersService.addFiles(orderId, payload).then(function (res) {
              var failedUploads = [];
              res.forEach(function (file) {
                if (file.error) {
                  failedUploads.push(file);
                } else {
                  dispatch({
                    type: 'ADD_DOCUMENT',
                    file: file
                  });
                  dispatch({
                    type: 'SET_DEFAULT_SIGNERS_ROLES',
                    payload: {
                      fileId: file.id,
                      fileCategory: 'document'
                    }
                  });
                }
              });
              if (failedUploads) dispatch({
                type: 'ADD_FAILED_UPLOADS',
                files: failedUploads
              });
            });
          case 2:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function (_x10) {
      return _ref6.apply(this, arguments);
    };
  }();
};
export var repairFile = function repairFile(orderId, fileId, category) {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(dispatch) {
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            dispatch({
              type: 'REPAIR_FILE_INIT',
              id: fileId,
              category: category
            });
            _context7.next = 3;
            return ordersService.repairFile(orderId, fileId).then(function (res) {
              dispatch({
                type: 'REPAIR_FILE_COMPLETED',
                id: fileId,
                fileIsValid: res.success,
                category: category
              });
            })["catch"](function (err) {
              dispatch({
                type: 'REPAIR_FILE_ERROR',
                id: fileId,
                category: category
              });
            });
          case 3:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function (_x11) {
      return _ref7.apply(this, arguments);
    };
  }();
};
export var cancel = function cancel(orderId, reason) {
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(dispatch) {
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt("return", ordersService.cancel(orderId, reason));
          case 1:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function (_x12) {
      return _ref8.apply(this, arguments);
    };
  }();
};
export var sendReminder = function sendReminder(orderId, signerId) {
  return /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(dispatch) {
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt("return", ordersService.sendReminder(orderId, signerId));
          case 1:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    return function (_x13) {
      return _ref9.apply(this, arguments);
    };
  }();
};
export var destroy = function destroy(orderId) {
  return /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(dispatch, getState) {
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            return _context10.abrupt("return", ordersService.destroy(orderId).then(function () {
              var state = getState();
              dispatch(getList(state.orders.offset, state.orders.filter, state.orders.orderBy, true));
            })["catch"](function (err) {
              throw err;
            }));
          case 1:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }));
    return function (_x14, _x15) {
      return _ref10.apply(this, arguments);
    };
  }();
};
export var restore = function restore(orderId) {
  return /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(dispatch) {
      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            return _context11.abrupt("return", ordersService.restore(orderId).then(function (result) {
              dispatch({
                type: 'ORDER_RESTORE_SUCCESS',
                order: result
              });
            })["catch"](function (err) {
              throw err;
            }));
          case 1:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    }));
    return function (_x16) {
      return _ref11.apply(this, arguments);
    };
  }();
};
export var changeDeadline = function changeDeadline(orderId, newDate) {
  return /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(dispatch) {
      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            return _context12.abrupt("return", ordersService.changeDeadline(orderId, newDate).then(function (result) {
              dispatch({
                type: 'ORDER_CHANGE_DEADLINE_SUCCESS',
                order: result
              });
            }));
          case 1:
          case "end":
            return _context12.stop();
        }
      }, _callee12);
    }));
    return function (_x17) {
      return _ref12.apply(this, arguments);
    };
  }();
};
export var addSessionUserAsRecipient = function addSessionUserAsRecipient(isOrdered) {
  return /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(dispatch, getState) {
      var _getState, session, profile;
      return _regeneratorRuntime().wrap(function _callee13$(_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            _getState = getState(), session = _getState.session;
            profile = session.user.profile;
            dispatch({
              type: 'ADD_RECIPIENT',
              recipient: {
                firstName: profile.firstName,
                lastName: profile.lastName,
                companyName: profile.companyName,
                companyRole: profile.companyRole,
                email: profile.email,
                mobileNumber: profile.mobile
              },
              isOrdered: isOrdered
            });
          case 3:
          case "end":
            return _context13.stop();
        }
      }, _callee13);
    }));
    return function (_x18, _x19) {
      return _ref13.apply(this, arguments);
    };
  }();
};
export var removeFileSignerRole = function removeFileSignerRole(fileId) {
  return /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(dispatch) {
      return _regeneratorRuntime().wrap(function _callee14$(_context14) {
        while (1) switch (_context14.prev = _context14.next) {
          case 0:
            dispatch({
              type: 'REMOVE_FILE_SIGNER_ROLES',
              fileId: fileId
            });
          case 1:
          case "end":
            return _context14.stop();
        }
      }, _callee14);
    }));
    return function (_x20) {
      return _ref14.apply(this, arguments);
    };
  }();
};
export default {
  cancel: cancel,
  getList: getList,
  getById: getById,
  destroy: destroy,
  restore: restore,
  saveSigner: saveSigner,
  removeFile: removeFile,
  addFiles: addFiles,
  repairFile: repairFile,
  removeSigner: removeSigner,
  sendReminder: sendReminder,
  addSessionUserAsRecipient: addSessionUserAsRecipient,
  changeDeadline: changeDeadline,
  removeFileSignerRole: removeFileSignerRole
};